import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface UserSessionData {
  uid: string;
  email: string | null;
  role: 'student' | 'avulso' | 'admin' | 'adm' | 'corretor' | 'professor' | 'secretaria' | null;
  userData?: any;
  photoUrl?: string | null;
}

interface AuthState {
  user: UserSessionData | null;
  isAuthenticated: boolean;
  login: (userData: UserSessionData) => void;
  logout: () => void;
  updatePhoto: (url: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      login: (userData) => set({ user: userData, isAuthenticated: true }),
      logout: () => set({ user: null, isAuthenticated: false }),
      updatePhoto: (url) => set((state) => ({ 
        user: state.user ? { ...state.user, photoUrl: url } : null 
      })),
    }),
    {
      name: 'education-saas-auth',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
